import * as Sentry from '@sentry/vue';
import { SessionController } from '@core/helpers/auth';

export const sentryLogException = (err, message) => {
  const { subdomain } = SessionController;

  Sentry.captureException(err, {
    tags: {
      client: subdomain,
    },
    extra: {
      reason: message,
    },
  });
};
